import type { UnknownAction } from 'redux';
import type { ColumnId, UpdatePageSettings2Input } from '../../gql/graphql';
import type { BookingsPerLoad, CompactMode } from '../grid/gridReducer';

export interface PageSettingsRehydratePayload {
  bookingsPerLoad: BookingsPerLoad;
  columnsEnabled: Partial<Record<ColumnId, boolean>>;
  columnsOrder: ColumnId[];
  columnsWidth: Partial<Record<ColumnId, number>>;
  compactMode: CompactMode;
  railEnabled: boolean;
}

export interface RehydratePageSettingsAction extends UnknownAction {
  payload: PageSettingsRehydratePayload;
  type: 'PAGE_SETTINGS:REHYDRATE';
}

export const rehydratePageSettings = (
  payload: PageSettingsRehydratePayload,
): RehydratePageSettingsAction => ({
  payload,
  type: 'PAGE_SETTINGS:REHYDRATE',
});

export interface RequestSavePageSettingsAction extends UnknownAction {
  payload: UpdatePageSettings2Input;
  type: 'PAGE_SETTINGS:REQUEST_SAVE';
}

export const requestSavePageSettings = (
  payload: UpdatePageSettings2Input,
): RequestSavePageSettingsAction => ({
  payload,
  type: 'PAGE_SETTINGS:REQUEST_SAVE',
});
